import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../services/mainApi.service";

const translationPath = "chatBot.page.service.ticketServiceArea.";

const TICKET_CHANNELS_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";
const ticketChannelsService = new MainApi(TICKET_CHANNELS_ROUTE);

export const TicketChannelOutsideBusinessDayField = memo(() => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();

  const valueChangeHandler = useCallback(() => {
    setValue("ticketChannelStepOutsideBusinessDay", null);
  }, [setValue]);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          getOptionLabel={(option) => {
            return option.name;
          }}
          size="small"
          label={t(translationPath + "ticket_channel")}
          name="ticketChannelOutsideBusinessDay"
          onValueChange={valueChangeHandler}
          request={ticketChannelsService.list}
        />
      </Grid>
    </>
  );
});
